<template>
  <v-text-field
    ref="field"
    v-bind="$attrs"
    :value="value"
    :readonly="isIsento"
    :rules="fieldRules"
    inputmode="numeric"
    :placeholder="$attrs.placeholder || '11 dígitos'"
    @input="onInput"
  >
    <template #append>
      <v-checkbox
        :input-value="isIsento"
        color="#BBCF20"
        :label="$t('Isento')"
        hide-details
        dense
        class="ma-0 pa-0"
        @change="onIsentoChange"
      ></v-checkbox>
    </template>
    <template #message="{ message }">
      {{ $t(message) }}
    </template>
  </v-text-field>
</template>

<script>
import NumberAnvisa from '../Utils/NumberAnvisa'

export default {
  name: 'NumberAnvisaField',

  inheritAttrs: false,

  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    isIsento() {
      return NumberAnvisa.isIsento(this.value)
    },

    fieldRules() {
      return [
        ...this.rules,
        (v) => NumberAnvisa.isValid(v) || NumberAnvisa.invalidMessage,
      ]
    },
  },

  methods: {
    onInput(raw) {
      const sanitized = NumberAnvisa.sanitize(raw)

      if (sanitized !== raw) this.$refs.field.lazyValue = sanitized

      this.$emit('input', sanitized)
    },

    onIsentoChange(checked) {
      this.$emit('input', checked ? NumberAnvisa.ISENTO : '')
    },
  },
}
</script>
